class RandomIdGenerator {
    constructor(length = 8) {
        this.length = length;
        this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    }

    generate() {
        let id = '';
        for (let i = 0; i < this.length; i++) {
            const randomIndex = Math.floor(Math.random() * this.characters.length);
            id += this.characters[randomIndex];
        }
        return id;
    }
}

export default RandomIdGenerator;